import { http } from '../../config/axios'

export default function inativarPerfil(idPerfil: string): Promise<string> {
  return http
    .patch('api/perfil/inativar/' + idPerfil)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro inativarPerfil', error)
      throw Error(error.response.data)
    })
}
